import { AddCircle } from '@mui/icons-material'
import { FC } from 'react'
import { useActions } from 'store/hooks'
import { Button } from 'ui'

import styles from './AddAddressBtn.module.scss'

interface IAddAddressBtn {
  onClick: (item: null) => void
}

// кнопка для добавления нового адреса (перехода в форму создания адреса)
export const AddAddressBtn: FC<IAddAddressBtn> = ({ onClick }) => {
  const { setCenter } = useActions()

  const handleClick = () => {
    onClick(null)
    setCenter(null)
  }

  return (
    <Button
      startIcon={<AddCircle color='primary' />}
      variant='contained'
      color='secondary'
      type='button'
      className={styles.addBtn}
      onClick={handleClick}
      data-testid='address-add-btn'
    >
      Новый адрес
    </Button>
  )
}
